export default "__VITE_ASSET__JPUAuuUi__"